import React, { useCallback, useEffect, useMemo, useState } from "react";
import { InputAdornment, TextField } from "@mui/material";
import { IBaseInput } from "./types";
import styles from "./BaseInput.styled";

const BaseInput: React.FC<IBaseInput> = ({
  id,
  label,
  type,
  name,
  sx,
  startAdornment: StartAdornment,
  endAdornment: EndAdornment,
  endAdornmentStr,
  onIconClick,
  formik,
  initialValue,
  placeholder,
  disabled = false,
}) => {
  const [inputValue, setInputValue] = useState(initialValue || "");

  useEffect(() => {
    if (initialValue) {
      setInputValue(initialValue);
    } else {
      setInputValue("");
    }
  }, [initialValue]);

  const inputStyles = { ...styles.inputWrap, ...sx };

  const isError = useMemo(
    () => formik.touched[name] && Boolean(formik.errors[name]),
    [formik.touched, formik.errors, name],
  );

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const { name, value } = event.target;
      formik.setFieldValue(name, value);
      setInputValue(value);
    },
    [formik],
  );

  const autoCompleteValue = type === "password" ? "current-password" : "on";

  return (
    <>
      <TextField
        id={id}
        type={type}
        name={name}
        label={label}
        sx={inputStyles}
        value={formik.values[name] || inputValue}
        autoComplete={autoCompleteValue}
        onChange={handleChange}
        onBlur={formik.handleBlur}
        error={isError}
        disabled={disabled}
        helperText={formik.touched[name] && formik.errors[name]}
        placeholder={placeholder}
        InputProps={{
          ...(StartAdornment && {
            startAdornment: (
              <InputAdornment position="start">
                <StartAdornment sx={styles.icon(isError)} />
              </InputAdornment>
            ),
          }),
          ...(endAdornmentStr && {
            endAdornment: (
              <InputAdornment position="end">{endAdornmentStr}</InputAdornment>
            ),
          }),
          ...(EndAdornment && {
            endAdornment: (
              <InputAdornment position="end">
                <div onClick={onIconClick}>
                  <EndAdornment sx={styles.visibilityIcon} />
                </div>
              </InputAdornment>
            ),
          }),
        }}
      />
    </>
  );
};

export default BaseInput;
